import { ValidateJSModel, EmailModel } from 'forms/shared/types';

const emailModelValidator: ValidateJSModel<EmailModel> = {
  name: {},

  emailType: (value, attributes, attributeName, options) => {
    if (attributes?.emailUnknown) {
      return {};
    }

    if (options.requireEmailType) {
      return {
        presence: true,
      };
    }

    return {};
  },

  value: (value, attributes, attributeName, options) => {
    if (attributes?.emailUnknown) {
      return {};
    }

    return { email: true, presence: true };
  },
  emailUnknown: {},

};

export default emailModelValidator;
